export default __webpack_public_path__ + "static/media/2_REFIN_Osmos_Ruggine-120x120_Matt.058c11eb.jpg";